'use client'
import React, { useMemo, useRef } from 'react'
import styles from './styles.module.scss'
import Slide from './Slide'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Game } from '@l2p/game-api'
import { useBreakpoint, useGenerateSlideBlocks } from '@l2p/apps-shared'

const initialCardsInSlide = {
  mobile: 3,
  tablet: 4,
  desktop: 4,
}
export type CardsInSlide = {
  mobile: number
  tablet: number
  desktop: number
}
interface OneRowCardsSliderProps {
  games: Game[]
  title?: string
  initialSlide?: number
  cardsInSlide?: CardsInSlide
  gameCardPlaceholder: string
}

const OneRowGamesSlider: React.FC<OneRowCardsSliderProps> = ({
  games,
  title,
  initialSlide,
  cardsInSlide = initialCardsInSlide,
  gameCardPlaceholder,
}) => {
  const slider = useRef<any>(null)
  const breakpoints = useBreakpoint()

  const cardsInTheSlide = useMemo(() => {
    if (breakpoints.mobile) return cardsInSlide?.mobile
    if (breakpoints.tablet) return cardsInSlide?.tablet
    return cardsInSlide?.desktop
  }, [breakpoints.mobile, breakpoints.tablet, cardsInSlide])

  const gamesToShow = useMemo(() => {
    let count
    if (breakpoints.mobile) count = 12
    else if (breakpoints.tablet) count = 8
    else count = 8
    return games.slice(0, count)
  }, [games, breakpoints])

  const slides = useGenerateSlideBlocks({
    cards: gamesToShow,
    cardsInSlide: cardsInTheSlide,
    countSlides: gamesToShow.length / cardsInTheSlide,
  })
  if (!slides || slides.length <= 0) return null

  return (
    <div className={styles.sliderWrapper}>
      <Swiper
        onBeforeInit={swiper => {
          slider.current = swiper
        }}
        className={styles.swiper}
        loop={true}
        spaceBetween={100}
        slidesPerView={1}
        pagination={{ clickable: true }}
        autoplay={false}
      >
        {slides.map((gamesForSlide, i) => (
          <SwiperSlide key={`slide${i}${title}`}>
            <Slide
              games={gamesForSlide}
              title={title}
              slider={slider}
              cuntSlides={slides.length}
              cardsInSlide={cardsInTheSlide}
              gameCardPlaceholder={gameCardPlaceholder}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default React.memo(OneRowGamesSlider)
